var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 7.49968V10.833M9.9999 14.1663H10.0082M8.5749 3.21635L1.51656 14.9997C1.37104 15.2517 1.29403 15.5374 1.29322 15.8284C1.2924 16.1195 1.3678 16.4056 1.51192 16.6585C1.65603 16.9113 1.86383 17.122 2.11465 17.2696C2.36547 17.4171 2.65056 17.4965 2.94156 17.4997H17.0582C17.3492 17.4965 17.6343 17.4171 17.8851 17.2696C18.136 17.122 18.3438 16.9113 18.4879 16.6585C18.632 16.4056 18.7074 16.1195 18.7066 15.8284C18.7058 15.5374 18.6288 15.2517 18.4832 14.9997L11.4249 3.21635C11.2763 2.97144 11.0672 2.76895 10.8176 2.62842C10.568 2.48789 10.2863 2.41406 9.9999 2.41406C9.71345 2.41406 9.43184 2.48789 9.18223 2.62842C8.93263 2.76895 8.72345 2.97144 8.5749 3.21635Z",
    stroke: "#F19571",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f6b184810b33d12c4f7a8c6cd0203bb9.svg";
export { ForwardRef as ReactComponent };